export class WebFormSummary {
  constructor(public title: string,
              public pageIndex: number,
              public fields: WebFormFieldSummary[]) {
  }
}

export class WebFormFieldSummary {
  constructor(public label: string, public value: string) {
  }
}
